// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "077422b-dirty",
    "hash": "077422b",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "077422b-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
